import React from "react";
import { PublicShell } from "./PublicShell";
import { SITE } from "@/constants/site";

export default function Terms() {
  return (
    <PublicShell
      title="Syarat & Ketentuan"
      subtitle={`Aturan penggunaan layanan ${SITE.serviceName}.`}
    >
      <p>
        Dengan mengakses dan menggunakan layanan {SITE.serviceName} ("Layanan"),
        Anda dianggap telah membaca, memahami, dan menyetujui seluruh syarat dan
        ketentuan berikut. Layanan ini dikelola oleh {SITE.name} ("Pengelola").
      </p>

      <h2>1. Definisi Layanan</h2>
      <p>
        Layanan merupakan sistem informasi keuangan berbasis web untuk pengelolaan
        pembayaran biaya pendidikan santri, uang jajan santri, tabungan santri,
        serta transaksi koperasi pesantren (Kopontren). Pembayaran daring diproses
        melalui payment gateway pihak ketiga yang bekerja sama dengan Pengelola.
      </p>

      <h2>2. Akun Pengguna</h2>
      <ul>
        <li>Akun dibuat dan diverifikasi oleh admin pesantren untuk orang tua/wali, kasir, dan admin.</li>
        <li>Pengguna wajib menjaga kerahasiaan nomor HP, kata sandi, dan PIN santri.</li>
        <li>Segala aktivitas yang terjadi melalui akun menjadi tanggung jawab pemilik akun.</li>
      </ul>

      <h2>3. Pembayaran</h2>
      <ul>
        <li>Nominal tagihan dan biaya ditetapkan oleh pihak pesantren sesuai ketentuan yang berlaku.</li>
        <li>Pembayaran dilakukan melalui metode yang tersedia (QRIS, Virtual Account, e-wallet, dan lainnya).</li>
        <li>Transaksi yang telah berhasil diproses akan tercatat otomatis dalam sistem dan memperbarui status tagihan/saldo.</li>
        <li>Biaya administrasi payment gateway (jika ada) mengikuti ketentuan penyedia dan/atau kebijakan pesantren.</li>
      </ul>

      <h2>4. Tanggung Jawab Pengguna</h2>
      <ul>
        <li>Memastikan data yang dimasukkan benar dan akurat.</li>
        <li>Memeriksa kembali nominal sebelum menyelesaikan pembayaran.</li>
        <li>Tidak menyalahgunakan Layanan untuk tujuan yang melanggar hukum.</li>
      </ul>

      <h2>5. Batasan Tanggung Jawab</h2>
      <p>
        Pengelola berupaya menjaga ketersediaan dan keakuratan Layanan, namun tidak
        bertanggung jawab atas kerugian yang timbul akibat kesalahan pengguna, gangguan
        jaringan, atau kegagalan sistem pihak ketiga di luar kendali Pengelola.
      </p>

      <h2>6. Perubahan Ketentuan</h2>
      <p>
        Pengelola dapat memperbarui syarat dan ketentuan ini sewaktu-waktu. Perubahan
        akan diumumkan melalui halaman ini. Penggunaan Layanan setelah pembaruan berarti
        Anda menyetujui ketentuan yang diperbarui.
      </p>

      <h2>7. Hubungi Kami</h2>
      <p>
        Untuk pertanyaan terkait syarat dan ketentuan, silakan hubungi kami di{" "}
        <a href={`mailto:${SITE.email}`}>{SITE.email}</a> atau{" "}
        <a href={`https://wa.me/${SITE.phoneRaw}`} target="_blank" rel="noreferrer">
          {SITE.phone}
        </a>
        .
      </p>
    </PublicShell>
  );
}
